export default __webpack_public_path__ + "static/media/failed-check.9ecd6bbb.gif";